import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import Estimates from "@/pages/Estimates";
import Customers from "@/pages/Customers";
import Vendors from "@/pages/Vendors";
import Expenses from "@/pages/Expenses";
import Receipts from "@/pages/Receipts";
import Bills from "@/pages/Bills";
import Banking from "@/pages/Banking";
import BankAccountLedger from "@/pages/BankAccountLedger";
import Reconciliation from "@/pages/Reconciliation";
import ChartOfAccounts from "@/pages/ChartOfAccounts";
import JournalEntries from "@/pages/JournalEntries";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Billing from "@/pages/Billing";
import AuditLog from "@/pages/AuditLog";
import DataHub from "@/pages/DataHub";
import DataHealth from "@/pages/DataHealth";
import Items from "@/pages/Items";
import Payments from "@/pages/Payments";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import HelpCenter from "@/pages/HelpCenter";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import VerifyEmail from "@/pages/VerifyEmail";
import UserManual from "@/pages/UserManual";
import SuperAdmin from "@/pages/SuperAdmin";

export default function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Toaster richColors position="top-right" />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/terms" element={<TermsOfService />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/manual" element={<UserManual />} />
                        <Route path="/onboarding" element={
                            <ProtectedRoute requireOrg={false}><Onboarding /></ProtectedRoute>
                        } />
                        <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                            <Route index element={<Dashboard />} />
                            <Route path="invoices" element={<Invoices />} />
                            <Route path="estimates" element={<Estimates />} />
                            <Route path="customers" element={<Customers />} />
                            <Route path="vendors" element={<Vendors />} />
                            <Route path="items" element={<Items />} />
                            <Route path="payments" element={<Payments />} />
                            <Route path="expenses" element={<Expenses />} />
                            <Route path="receipts" element={<Receipts />} />
                            <Route path="bills" element={<Bills />} />
                            <Route path="banking" element={<Banking />} />
                            <Route path="banking/:id" element={<BankAccountLedger />} />
                            <Route path="reconciliation" element={<Reconciliation />} />
                            <Route path="coa" element={<ChartOfAccounts />} />
                            <Route path="journal" element={<JournalEntries />} />
                            <Route path="reports" element={<Reports />} />
                            <Route path="team" element={<Team />} />
                            <Route path="data" element={<DataHub />} />
                            <Route path="data-health" element={<DataHealth />} />
                            <Route path="billing" element={<Billing />} />
                            <Route path="audit" element={<AuditLog />} />
                            <Route path="help" element={<HelpCenter />} />
                            <Route path="help/:slug" element={<HelpCenter />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="superadmin" element={<SuperAdmin />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
